import type {ReactElement} from 'react';
import {useAiChatLayout} from '@AiChat/hooks/useAiChatLayout';
import {useAiChatSeason} from '@AiChat/hooks/useAiChatSeason';
import {AiChatSeason} from '@AiChat/lib/ai-chat-season-library.types';
import {AiChatHalloweenSpiderWeb} from '@AiChat/components/ai-chat-halloween-spider-web/ai-chat-halloween-spider-web';
import {assertNever} from '@Utils/assert-never.util';

export function AiChatSeasonalPageDecorations(): ReactElement | null {
  const {isMobileLayout} = useAiChatLayout();
  const season = useAiChatSeason();

  if (isMobileLayout || !season) {
    return null;
  }

  switch (season) {
    case AiChatSeason.HALLOWEEN:
      return <AiChatHalloweenSpiderWeb />;
    default:
      return assertNever(season);
  }
}
